import { render, staticRenderFns } from "./qrReader.vue?vue&type=template&id=ed496b10&scoped=true&"
import script from "./qrReader.vue?vue&type=script&lang=js&"
export * from "./qrReader.vue?vue&type=script&lang=js&"
import style0 from "./qrReader.vue?vue&type=style&index=0&id=ed496b10&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed496b10",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
